import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { TopbarComponent } from './layouts/topbar/topbar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, HTTP_INTERCEPTORS, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
//import { provideClientHydration } from '@angular/platform-browser/animations';
import { LoginComponent } from './layouts/login/login.component';
import { DocumentsComponent } from './features/documents/documents.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { HealthComponent } from './features/health/health.component';
import { ConnectionsComponent } from './features/connections/connections.component';
import { CalendarComponent } from './features/calendar/calendar.component';
import { ChatsComponent } from './features/chats/chats.component';
import { NotificationsComponent } from './features/notifications/notifications.component';
import { SettingsComponent } from './features/settings/settings.component';
import { LogoutComponent } from './features/logout/logout.component';
import { ResetPasswordComponent } from './layouts/reset-password/reset-password.component';
import { RegisterComponent } from './layouts/register/register.component';
import { ForgotPasswordComponent } from './layouts/forgot-password/forgot-password.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { RouterModule, Routes } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableModule } from '@angular/material/table';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatStepperModule } from '@angular/material/stepper'; 
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { MailVerificationComponent } from './layouts/mail-verification/mail-verification.component';
//import { Ng2SearchPipeModule } from 'ng2-search-filter';
//import { FilterPipe } from './shared/pipes/filter.pipe';
import { SharedModule } from './shared/shared.module';
import { AudittrailsComponent } from './features/audittrails/audittrails.component';
import { CommonModule, DatePipe } from '@angular/common';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { RecurringEditDialogComponent } from './features/calendar/add-calendar-dialog/add-calendar-dialog.component';
import { ChangePasswordDialogComponent } from './features/settings/profile-information/change-password-dialog/change-password-dialog.component';
import { AddCountryComponent } from './features/settings/country-affiliation/add-country/add-country.component';
import { DoctypePipe } from './doctype.pipe';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AlertDialogComponent } from './features/calendar/add-calendar-dialog/add-calendar-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgChartsModule } from 'ng2-charts';
import { WheelTimepickerDialogComponent } from './shared/time/wheel-timepicker-dialog.component';
import { ConfirmationDialogComponent } from './features/health/healthdashbord/healthdashbord.component';

@NgModule({ 
  declarations: [
        AppComponent,
        SidebarComponent,
        TopbarComponent,
        LoginComponent,
        DocumentsComponent,
        DashboardComponent,
        ConnectionsComponent,
        CalendarComponent,
        ChatsComponent,
        NotificationsComponent,
        ForgotPasswordComponent,
        RegisterComponent,
        AudittrailsComponent,
        ResetPasswordComponent,
        SettingsComponent,
        LogoutComponent,
        MailVerificationComponent,
        RecurringEditDialogComponent,
        AlertDialogComponent,
        ChangePasswordDialogComponent,
        AddCountryComponent,
        DoctypePipe,
        WheelTimepickerDialogComponent,
        ConfirmationDialogComponent,
        //FilterPipe
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], 
    imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        CommonModule,
        MatSnackBarModule,
        MatCheckboxModule,
        MatMenuModule,
        MatSelectModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatTableModule,
        MatDatepickerModule,
        MatStepperModule,
        MatChipsModule,
        MatPaginatorModule,
        MatTabsModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatExpansionModule,
        MatAutocompleteModule,
        NgChartsModule,
        //Ng2SearchPipeModule,
        
        SharedModule,
        ToastrModule.forRoot({
            timeOut: 3000,
            positionClass: "toast-top-right",
            preventDuplicates: true,
        })], 
        providers: [
        // provideClientHydration(),
        // provideHttpClient(withFetch()),
         provideHttpClient(),
        ToastrService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // dd/MM/yyyy
        DatePipe,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
